import React, { FC } from 'react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { useVisibilityCheck } from '../../hooks/useVisibilityCheck';
import { useWidgetViewModel } from '../hooks/useWidgetViewModel';
import { Title } from './Title/Title';
import { ListFilter } from './ListFilter/ListFilter';
import { st, classes } from './Header.st.css';
import { DataHooks } from './consts';

export const Header: FC = () => {
  const { isMobile } = useEnvironment();
  const { shouldBeVisible } = useVisibilityCheck();
  const { headerViewModel } = useWidgetViewModel();
  const isTitleVisible = shouldBeVisible('isTitleVisible');
  const { isListFilterVisible } = headerViewModel;

  return isTitleVisible || isListFilterVisible ? (
    <div className={st(classes.root, { isMobile })} data-hook={DataHooks.ROOT}>
      {isTitleVisible ? <Title /> : null}
      {isListFilterVisible ? <ListFilter /> : null}
    </div>
  ) : null;
};
